import React from "react";
import style from './Section.module.css';
import Posts from "./Posts/Posts";
import Profile from "./Profile/Profile";
import PostsContainer from "./Posts/PostsContainer";

const Section = () => {
    return (
        <section id="profile" className={style.profilePage}>
            <Profile />
            <PostsContainer />
        </section>
    )
}

export default Section;